require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./godel-escher-bach.json") })
        }
      }, "path---godel-escher-bach");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---godel-escher-bach!./.cache/json/godel-escher-bach.json
// module id = 839
// module chunks = 231608221292675